<template>
	<div>
		<el-dialog title="编辑文章" :visible.sync="_addActVisible" width="55%">
		    <el-tabs v-model="activeName" @tab-click="handleClick">
		        <el-tab-pane label="未选文章列表" name="first">
		            <el-input clearable style="padding:10px 0;width:300px" size="small" placeholder="请输入文章标题" suffix-icon="el-icon-search" v-model="docTitle">
		            </el-input>
		            <el-button :disabled='disabled1' style="float:right" type="primary" @click="moreAdd" size="mini">批量添加</el-button>
		            <myTable isSelection :loading="loading1" :tableData="NonexistenceList" :tableHeader="tableHeader" @handleSelectionChange='handleSelectionChange1'>
		            </myTable>
		            <my-pagination :childMsg="pageParams" @callFather="callFather" />
		        </el-tab-pane>
		        <el-tab-pane label="已选文章列表" name="second">
		            <el-input clearable style="padding:10px 0;width:300px" size="small" placeholder="请输入文章标题" suffix-icon="el-icon-search" v-model="docTitle2">
		            </el-input>
		            <el-button style="float:right" size="mini" :disabled='disabled' type="primary" @click="moreDelete">批量删除</el-button>
		            <myTable isSelection :loading="loading2" :tableData="existingArticleLIst" :tableHeader="tableHeader" @handleSelectionChange='handleSelectionChange'>
		            </myTable>
		            <my-pagination :childMsg="pageParams2" @callFather="callFather2" />
		        </el-tab-pane>
		    </el-tabs>
		</el-dialog>
		<!-- 详情对话框 -->
		<el-dialog title="文章内容" :visible.sync="actileDetalis" width="55%">
		    <div class="articalContent" v-html="transHtml" v-loading="loading2"></div>
		</el-dialog>
	</div>
   
</template>

<script>
import { resourcesList, addResource, noChannelDoclistPage, deleteChannelDoclist } from "@/network/content/channel.js";
import { articeDetails } from "@/network/content/artice";
export default {
    name: "",
    props: {
        addActVisible: {
            type: Boolean,
            default: false,
        },
        channelId: {
            type: Number,
            default: 0,
        },
        unitId: {
            type: String,
            default: '',
        },
		payModel:{
			 default: '',
		}
    },
    data() {
        return {
            activeName: "first",
            docTitle: "",
            docTitle2: "",
            loading1: true,
            loading2: true,
            tableHeader: Object.freeze([
                {
                    name: "文章名称",
                    prop: "docTitle",
                },
				{
				    name: "发布时间",
				    prop: "startTime",
				},
				{
				    name: "操作",
				    prop: "operation",
				    operation: [
				        {
				            name: "详情",
				            clickFun: this.detailArtice,
				            show: true,
				        }
				    ],
				},
				]),
            NonexistenceList: [],
            existingArticleLIst: [],
            pageParams: {
                currentPage: 1,
                pageSize: 10,
                total: 0,
            },
            pageParams2: {
                currentPage: 1,
                pageSize: 10,
                total: 0,
            },
            selectList: [],
            selectList1: [],
			actileDetalis:false,
			transHtml:""
        };
    },
    computed: {
        _addActVisible: {
            get() {
                return this.addActVisible;
            },
            set(val) {
                this.$emit("update:addActVisible", val);
            },
        },
        disabled() {
            return !this.selectList.length
        },
        disabled1() {
            return !this.selectList1.length
        },
    },
    watch: {
        docTitle() {
            clearTimeout(this.interval)
            this.interval = setTimeout(() => {
                this.getNonexistenceArticle()
            }, 500)
        },
        docTitle2() {
            clearTimeout(this.interval2)
            this.interva2 = setTimeout(() => {
                this.getExistingArticle()
            }, 500)
        }
    },
    methods: {
        handleClick(tab) {
            console.log(tab.name);
        },
        handleSelectionChange(val) {
            this.selectList = val.map((item) => {
                return item.deleteId
            })
        },
        handleSelectionChange1(val) {
            this.selectList1 = val.map((item) => {
                return item.id
            })
        },
        callFather(parm) {
            this.pageParams.currentPage = parm.currentPage;
            this.pageParams.pageSize = parm.pageSize;
            this.getNonexistenceArticle();
        },
        callFather2(parm) {
            this.pageParams2.currentPage = parm.currentPage;
            this.pageParams2.pageSize = parm.pageSize;
            this.getExistingArticle();
        },
        getNonexistenceArticle() { //未选文章列表
            let params = {
                data: {
                    unitId: this.unitId,
                    channelId: this.channelId,
                    docTitle: this.docTitle
                },
                current: this.pageParams.currentPage,
                size: this.pageParams.pageSize,
            };
			if(this.payModel==3){
				params.data.payModel = this.payModel;
			}
            noChannelDoclistPage(params).then((res) => {
                let { code, data } = res.data;
                if (code == 200) {
                    this.NonexistenceList = data.records;
                    this.pageParams.total = data.total
                    this.loading1 = false
                }
            });
        },
        getExistingArticle() { //已选文章列表
            let params = {
                data: {
                    channelId: this.channelId,
                    docTitle: this.docTitle2
                },
                current: this.pageParams2.currentPage,
                size: this.pageParams2.pageSize,
            };
			if(this.payModel==3){
				params.data.payModel = this.payModel;
			}
            resourcesList(params).then((e) => {
                let { code, data } = e.data;
                if (code == 200) {
                    this.loading2 = false
                    this.existingArticleLIst = data.records;
                    this.pageParams2.total = data.total
                }
            });
        },
        // 批量删除
        moreDelete() {
            deleteChannelDoclist({ ids: this.selectList }).then((e) => {
                let { code } = e.data;
                if (code == 200) {
                    this.$message('删除成功')
                    this.getNonexistenceArticle()
                    this.getExistingArticle()
                    this.$bus.$emit('clearSelection')
                    this.selectList = []
                }
            }
            )
        },
        // 批量添加
        moreAdd() {
            let param = {
                channelId: this.channelId,
                docIdList: this.selectList1
            }
            addResource(param).then((e) => {
                let { code } = e.data;
                if (code == 200) {
                    this.$message('添加成功')
                    this.getNonexistenceArticle()
                    this.getExistingArticle()
                    this.$bus.$emit('clearSelection')
                    this.selectList1 = []
                }
            }
            )

        },
		// 文章详情
		detailArtice(item){
			this.actileDetalis = true;
			this.loading2 = true;
			this.transHtml = "";
			articeDetails({
			    docId: item.id,
			})
			    .then((res) => {
			        if (res.data.code == 200) {
			            var data = res.data.data;
						if(data.language=="en"){
							console.log('英文')
							this.transHtml = data.transHtml;
						}else{
							this.transHtml = data.html;
						}
			            
			        }
			        this.loading2 = false;
			    })
			    .catch((err) => { });
		}
    },
    created() {
        this.getNonexistenceArticle()  //未选的
        this.getExistingArticle() //已选的
    }
};
</script>

<style lang="scss" scoped>
.articalContent {
	width: 100%;
	height: 60vh;
	overflow: auto;
	/deep/img{
		width: 100%;
	}
}
::v-deep .el-dialog__body {
    padding-top: 0;
    // padding-bottom: 0;
    // padding-right: 0;
}
// ::v-deep .el-dialog__header {
//     border-bottom: 1px solid #eee;
// }

// /* 左侧菜单栏滚动条样式 */
// ::-webkit-scrollbar {
//     width: 8px;
//     height: 8px;
// }

// ::-webkit-scrollbar-track {
//     /* background: rgba(43,70,109,1); */
//     border-radius: 3px;
// }

// ::-webkit-scrollbar-track-piece {
//     /* 内层轨道，滚动条中间部分（位置4） */
//     border-radius: 2px 2px 0px 0px;
// }

// ::-webkit-scrollbar-thumb {
//     background: #c7c9cc;
//     border-radius: 6px;
// }
</style>
